export default "__VITE_ASSET__jQ6en3IA__"